<template>
  <div>
    <div class="footerTop">
      <div class="mainContent">
        <div class="footer_warpper">
          <!--          <div class="item left">-->
          <!--            <div class="imgWarpper">-->
          <!--              <img class="img" src="../../assets/images/logo4.png" alt srcset />-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="item left">
            <span class="title">关于我们/About Us</span>
            <div class="content">{{ agreemenInfo.info }}</div>
          </div>
          <div class="item left contact">
            <!-- <img v-if="agreemenInfo.wechat_code" :src="agreemenInfo.wechat_code" alt /> -->
            <div class="cText">
              <span class="title">关注我们/Follow Us</span>
              <p class="content">扫一扫关注</p>
              <p class="content">{{ agreemenInfo.wechat_name }}</p>
            </div>
          </div>
          <div class="item" style="width: auto">
            <span class="title">联系我们/Contact Us</span>
            <p class="content">电话：{{ agreemenInfo.mobile }}</p>
            <p class="content">地址：{{ agreemenInfo.address }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footerTab">
      <div class="content">
        <!--        <div class="item">关于我们 | 联系我们</div>-->
        <div class="item">
          <span class="span" v-text="icp_number"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils";

import { agreemenInfo } from "@/api";
export default {
  data () {
    return {
      agreemenInfo: {},
      icp_number: util.icp_number,
      websiteTitle: util.copyrightName + util.WebsiteTitle,
    };
  },
  mounted () {
    // this.initData();
  },
  methods: {
    async initData () {
      try {
        const params = {};
        let res = await agreemenInfo(params);
        if (res.success) this.agreemenInfo = res.result;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.span {
  background: url(../../assets/images/icon1.png) 0 center no-repeat;
  padding-left: 20px;
}
.footerTop {
  width: 100%;
  background: #222222;
  padding: 10px 0;
  // text-align: center;
  .follow {
    text-align: center;
    color: #fff;
    font-size: 16px;
  }
  .text {
    color: #999;
    margin: 30px 0 15px;
  }
  .qrImg {
    width: 100px;
    margin-top: 10px;
  }
  .text1 {
    color: #5b5b5b;
    span {
      background: url("../../assets/images/icon1.png") 0 center no-repeat;
      padding-left: 15px;
    }
  }

  .mainContent {
    // width: 1200px;
    margin: 0 auto;
    height: 120px;
    background: #222222;
    padding: 40px 0 25px 0;
    .footer_warpper {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .item {
        width: 251px;
        height: 90px;
        line-height: 22px;
        padding: 0 20px;
        .imgWarpper {
          text-align: center;
          .img {
            width: 100%;
          }
        }
        .title {
          font-size: 16px;
          color: #fff;
          display: inline-block;
          margin-bottom: 10px;
        }
        .content {
          font-size: 14px;
          color: #999999;
          .el-select {
            padding-top: 15px;
            ul {
              a {
                text-decoration: none;
              }
            }
          }
        }
      }
      .contact {
        display: flex;
        line-height: 22px;
        img {
          width: 36%;
        }
        .cText {
          padding-left: 10px;
          width: 230px;
        }
      }
    }
  }
}

.footerTab {
  width: 100%;
  background: #192227;
  height: 54px;
  .content {
    font-size: 14px;
    color: #999999;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    .item {
      margin: auto;
    }
  }
}
</style>
